import {useRef} from 'react';
import {InputWrapper, InputBox, ErrorMessage, Container} from './styled';

type Props = {
  length?: number;
  value: string;
  onChange: (val: string) => void;
  errorMessage?: string;
};

export const EmailCodeInput = ({length = 6, value, onChange, errorMessage}: Props) => {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, idx: number) => {
    let val = e.target.value.replace(/\D/g, '');
    if (!val) val = '';
    const newValue = value.split('');
    if (val.length > 1) {
      // Multiple paste
      val.split('').forEach((char, i) => {
        if (idx + i < length) {
          newValue[idx + i] = char;
        }
      });
      onChange(newValue.join('').slice(0, length));
      const next = Math.min(idx + val.length, length - 1);
      inputsRef.current[next]?.focus();
      return;
    }
    newValue[idx] = val;
    onChange(newValue.join('').slice(0, length));
    if (val && idx < length - 1) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, idx: number) => {
    if (e.key === 'Backspace' && !value[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>, idx: number) => {
    const paste = e.clipboardData.getData('Text').replace(/\D/g, '');
    if (paste) {
      const newValue = value.split('');
      paste.split('').forEach((char, i) => {
        if (idx + i < length) {
          newValue[idx + i] = char;
        }
      });
      onChange(newValue.join('').slice(0, length));
      const next = Math.min(idx + paste.length, length - 1);
      setTimeout(() => inputsRef.current[next]?.focus(), 0);
      e.preventDefault();
    }
  };

  return (
    <Container>
      <InputWrapper>
        {Array.from({length}).map((_, idx) => (
          <InputBox
            key={idx}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={value[idx] || ''}
            onChange={e => handleChange(e, idx)}
            onKeyDown={e => handleKeyDown(e, idx)}
            onPaste={e => handlePaste(e, idx)}
            ref={el => (inputsRef.current[idx] = el)}
          />
        ))}
      </InputWrapper>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};
